import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentBlock from "../Layout/ContentBlock";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import { ButtonInfo, CheckBoxInput, SelectForm } from "../common/Buttons";
import { IconEye, IconEyeInvisible } from "../Layout/Icons";
import { ButtonWithImumHistory, DebounceSelect } from "../common";
import {
  antdMessageInfo,
  exportDocument,
  formatDatePlus,
  getDateFormat,
} from "../../helpers/Utils";
import {
  exportImumToAlso,
  getImums,
  getImumsOptions,
  getImumXls,
  imumCheckIfHaveDifference,
  imumMassChangePriceToOldPrice,
  imumDisableChannelPriceScope,
  imumDisableChannelPriceScopeParams,
} from "../../redux/Actions/imum_action";
import errorHandler from "../../helpers/ErrorHandler";
import Axios from "axios";
import useDebounce from "../../hooks/useDebounce";
import SwitchComp from "../common/SwitchComp";
import SelectInput from "../common/SelectInput";
import ImumProductTable from "../ImumToAkeneoScreen/ImumProductTable";
import ImumModalPreliminaryPreview from "../ImumToAkeneoScreen/ImumModalPreliminaryPreview";
import { Label, SelectCountry } from "../globals";
import Spinner from "../common/Spinner";
import DataPickerInputModal from "../common/DataPickerInputModal";
import { getLocalStorage, setLocalStorage } from "../../utils/localstorage";
import { AnimatePresence, motion } from "framer-motion";
import InstructionButton from "../InstructionButton/InstructionButton";
import ImumTagImport from "./ImumTagImport";
import ImumBulkTagAction from "./ImumBulkTagAction";
import {
  QueryClient,
  QueryClientProvider,
} from "react-query";

export const queryClient = new QueryClient();

const filterInitial = {
  product_code: "",
  product_name: "",
  changed_price: false,
  failure_date: null,
  family_name: "",
  brand: [],
  competitor: [],
  cheapest_competitor: "",
  price_changes: "",
  table_sort: {
    lang: "",
    sort: "",
    type: "",
  },
  product_active: "",
  tag_ids: [],
  imum_rule_ids: [],
  tag_status: false,
  imum_prices_export_date: null,
  imum_prices_imum_rule_ids: [],
  no_competition: false,
  user: "",
};
const defaultLangs = ["LT", "LV", "EE", "FI"];

const ImumExport = ({
  page,
  setPage,
  failed = false,
  record_type,
  modal,
  totalLength,
}) => {
  console.log({ failed });
  const dispatch = useDispatch();
  const user_id = useSelector((state) => state.auth.user.id);
  const { current, loading, data, options, totals } = useSelector(
    (state) => state.custom
  );
  const [filters, setFilters] = useState(filterInitial);
  const [filterString, setfilterString] = useState("");
  const [hiddenFilters, setHiddenFilters] = useState(false);
  const [checked, setChecked] = useState([]);
  const [bulkTagModalVisible, setBulkTagModalVisible] = useState(false);
  const isInitialMount = useRef(true);
  const [hasMore, setHasMore] = useState(false);
  const [preliminaryPreview, setPreliminaryPreview] = useState({
    preview: false,
    record: {},
  });
  const [countriesAreDisplayed, setCountriesAreDisplayed] = useState(
    record_type == "technorama" ? ["LT"] : defaultLangs
  );

  useEffect(() => {
    if (current !== "imum") return;
    // hacking with dom elements
    const items = document
      .querySelector(".select_with_hidden_items")
      .querySelectorAll(".ant-select-selection-item");
    if (items.length < 3)
      return items.forEach((d) => (d.style.display = "flex"));
    items.forEach((d) => (d.style.display = "none"));
    [...items]
      .slice(items.length - 3, items.length)
      .forEach((d) => (d.style.display = "flex"));
  }, [filters?.competitor?.length]);
  console.log(filters);
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useDebounce(
    () => {
      console.log("DEBOUNCE table sort");
      onFilter();
    },
    1000,
    [
      filters?.table_sort?.sort,
      filters?.table_sort?.lang,
      filters?.table_sort?.type,
    ]
  );

  useEffect(() => {
    dispatch(getImumsOptions());
    getLocalStorage("imum_hidden_filters").then((hidden_filters) => {
      if (typeof hidden_filters == "boolean") {
        setHiddenFilters(hidden_filters);
      }
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: "LOADING_CUSTOM",
    });
  }, [filterString]);

  const trig = async () => {
    try {
      const { success, has_more } = await dispatch(
        getImums(
          page,
          filterString,
          preliminaryPreview?.preview ? "ImumModal" : "Imum"
        )
      );
      if (success) setHasMore(has_more);
      console.log({ success, has_more });
    } catch (err) {
      console.log({ err });
    }
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (!!filterString) {
        trig();
      } else if (!failed) {
        trig();
      }
    }
  }, [filterString, page]);

  useEffect(() => {
    if (modal == "") {
      onFilter(true);
    }
  }, [modal]);

  useEffect(() => {
    dispatch({
      type: "LOADING_CUSTOM",
    });
    onFilter(true);
  }, [preliminaryPreview?.preview, failed]);

  // Functions
  const onFilter = (force = false) => {
    let filterParams = "";
    const displayedCountriesArray =
      window.identifier == "technorama" ? ["tch"] : countriesAreDisplayed;

    if (failed) {
      filterParams += `&q[imum_export_logs_id_not_null]=1`;
    }

    if (filters.no_competition) {
      displayedCountriesArray.forEach((d) => {
        filterParams += `&q[no_new_prices][]=${d?.toLocaleLowerCase()}`;
      });
    }

    if (failed && filters.failure_date) {
      filterParams += `&q[imum_export_logs_created_at_gteq]=${filters.failure_date
        }&q[imum_export_logs_created_at_lteq]=${formatDatePlus(
          filters.failure_date
        )}`;
    }
    if (!failed && filters.imum_prices_export_date) {
      filterParams += `&q[imum_prices_export_date_gteq]=${filters.imum_prices_export_date
        }&q[imum_prices_export_date_lteq]=${formatDatePlus(
          filters.imum_prices_export_date
        )}`;
    }

    if (failed && !!filters.imum_rule_ids && filters.imum_rule_ids.length > 0) {
      filters.imum_rule_ids.forEach((s) => {
        filterParams += `&q[imum_export_logs_imum_rule_id_in][]=${s}`;
      });
    }
    if (
      !failed &&
      !!filters.imum_prices_imum_rule_ids &&
      filters.imum_prices_imum_rule_ids.length > 0
    ) {
      filters.imum_prices_imum_rule_ids.forEach((s) => {
        filterParams += `&q[imum_prices_imum_rule_id_in][]=${s}`;
      });
    }

    if (filters.tag_ids?.length > 0) {
      if (filters.tag_ids.includes("")) {
        filterParams += `&q[${window.identifier == "technorama" ? "tch_tag_ids" : "tag_ids"
          }_raw_blank]=${filters.tag_status ? "0" : "1"}`;
      } else {
        if (filters.tag_status) {
          filterParams += `&q[${window.identifier == "technorama" ? "tch_tag_ids" : "tag_ids"
            }_raw_not_cont_any][]=${filters.tag_ids
              .map((id) => "-%20" + id + "%0A")
              .join(
                `&q[${window.identifier == "technorama" ? "tch_tag_ids" : "tag_ids"
                }_raw_not_cont_any][]=`
              )}`;
        } else {
          filterParams += `&q[${window.identifier == "technorama" ? "tch_tag_ids" : "tag_ids"
            }_raw_cont_any][]=${filters.tag_ids
              .map((id) => "-%20" + id + "%0A")
              .join(
                `&q[${window.identifier == "technorama" ? "tch_tag_ids" : "tag_ids"
                }_raw_cont_any][]=`
              )}`;
        }
      }
    }
    //
    if (filters.product_code)
      filterParams += `&q[product_code_cont_any]=${filters.product_code}`;
    if (filters.product_name)
      filterParams += `&q[product_code_cont_any]=${filters.product_name}`;
    if (filters.brand) {
      filters.brand.forEach((brand) => {
        filterParams += `&q[brand_cont_any][]=${brand}`;
      });
    }

    if (filters.family_name) {
      if (filters.family_name === "no_category") {
        filterParams += `&q[imum_category_null]=1`;
      } else {
        filterParams += `&q[imum_category_cont_any]=${encodeURIComponent(filters.family_name)}`;
      }
    }
    if (!failed && filters.changed_price) {
      filterParams += `&q[imum_prices_changed_price_true]=${filters.changed_price ? "1" : "0"
        }`;
      displayedCountriesArray.forEach((value) => {
        filterParams += `&q[imum_prices_country_in][]=${value}`;
      });
    }

    if (filters.competitor) {
      filters.competitor.forEach((d) => {
        filterParams += `&q[imum_supplier_prices_shop_in][]=${d}`;
      });
    }

    if (filters.cheapest_competitor) {
      if (window.identifier == "technorama") {
        filterParams += `&q[cheapest_tch_eq]=${filters.cheapest_competitor}`;
      } else {
        let groupParams = "";
        displayedCountriesArray.forEach((d) => {
          groupParams += `&q[g][1][cheapest_${d?.toLocaleLowerCase()}_eq]=${filters.cheapest_competitor
            }`;
        });
        filterParams += `&q[g][1][m]=or${groupParams}`;
      }
    }

    if (filters.user) {
      filterParams += `&q[imum_export_logs_imum_rule_user_id_or_imum_export_logs_imum_rule_editor_id_eq]=${filters.user}`;
    }

    // Sortinimas
    if (
      filters.table_sort?.lang &&
      filters.table_sort?.sort &&
      filters.table_sort?.type
    ) {
      filterParams += `&q[s]=${filters.table_sort.type}${filters.table_sort.lang.trim()
        ? `_${window.identifier == "technorama"
          ? "tch"
          : filters.table_sort.lang.toLowerCase()
        }`
        : ""
        }+${filters.table_sort.sort}`;
    }

    if (filters.price_changes) {
      if (filters.price_changes == "positive_changes") {
        if (countriesAreDisplayed.includes("LT"))
          filterParams += `&q[change_${window.identifier == "technorama" ? "tch" : "lt"
            }_gt]=0`;
        if (countriesAreDisplayed.includes("LV"))
          filterParams += `&q[change_lv_gt]=0`;
        if (countriesAreDisplayed.includes("EE"))
          filterParams += `&q[change_ee_gt]=0`;
        if (countriesAreDisplayed.includes("FI"))
          filterParams += `&q[change_fi_gt]=0`;
      }
      if (filters.price_changes == "negative_changes") {
        if (countriesAreDisplayed.length > 0)
          filterParams += `&q[${(window.identifier == "technorama"
            ? ["TCH"]
            : countriesAreDisplayed
          )
            .map((d) => `change_${d.toLowerCase()}`)
            .join("_or_")}_lt]=0`;
      }
      if (filters.price_changes == "no_changes") {
        if (countriesAreDisplayed.includes("LT"))
          filterParams += `&q[change_${window.identifier == "technorama" ? "tch" : "lt"
            }_in]=0`;
        if (countriesAreDisplayed.includes("LV"))
          filterParams += `&q[change_lv_in]=0`;
        if (countriesAreDisplayed.includes("EE"))
          filterParams += `&q[change_ee_in]=0`;
        if (countriesAreDisplayed.includes("FI"))
          filterParams += `&q[change_fi_in]=0`;
      }
    }
    if (filters.product_active && filters.product_active !== "out_of_stock") {
      const product_active_val = filters.product_active == "active" ? "1" : "0";
      if (countriesAreDisplayed.includes("LT"))
        filterParams += `&q[active_${window.identifier == "technorama" ? "tch" : "lt"
          }_true]=${product_active_val}`;
      if (countriesAreDisplayed.includes("LV"))
        filterParams += `&q[active_lv_true]=${product_active_val}`;
      if (countriesAreDisplayed.includes("EE"))
        filterParams += `&q[active_ee_true]=${product_active_val}`;
      if (countriesAreDisplayed.includes("FI"))
        filterParams += `&q[active_fi_true]=${product_active_val}`;
    }
    if (filters.product_active == "out_of_stock") {
      filterParams += `&q[imum_supplier_prices_active_false]=1`;
      if (countriesAreDisplayed.includes("LT"))
        filterParams += `&q[imum_supplier_prices_category_in][]=${window.identifier == "technorama" ? "tch" : "lt"
          }`;
      if (countriesAreDisplayed.includes("LV"))
        filterParams += `&q[imum_supplier_prices_category_in][]=LV`;
      if (countriesAreDisplayed.includes("EE"))
        filterParams += `&q[imum_supplier_prices_category_in][]=EE`;
      if (countriesAreDisplayed.includes("FI"))
        filterParams += `&q[imum_supplier_prices_category_in][]=FI`;
    }
    if (preliminaryPreview?.preview) {
      filterParams = `&imums_ids=${checked.join(",")}`;
    }

    if (force && filterString == filterParams && page == 1) {
      trig();
    } else {
      setfilterString(filterParams);
      setPage(1);
    }
    setChecked([]);
  };

  const fetchOptions4Filter = async (value, type) => {
    try {
      let api_url = `/api/v1/imums/simple_imum_products?q[brand_i_cont_any]=${value}`;
      if (type === "user" && value?.length < 3) {
        return [
          {
            label: "No data available",
            value: "",
          },
        ];
      }
      if (type === "family") {
        api_url = `/api/v1/imums/simple_imum_products?q[imum_category_i_cont_any]=${value}`;
      } else if (type === "product_code") {
        api_url = `/api/v1/imums/simple_imum_products?q[product_code_i_cont_any]=${value}`;
      } else if (type === "product_name") {
        api_url = `/api/v1/imums/simple_imum_products?q[product_name_i_cont_any]=${value}`;
      } else if (type === "user" && value?.length >= 3) {
        api_url = `/api/v1/users?q[firstname_i_cont]=${value}&q[deleted_at_null]=true`;
      }

      const { data } = await Axios.get(api_url);
      const valArr = data?.data || [];

      const options = [
        {
          label: "No data selected",
          value: "",
        },
        ...valArr.map((e) => {
          if (type === "user") {
            return {
              value: e.id,
              label: `${e.firstname} ${e.lastname}`,
            };
          } else if (["product_name", "product_code"].includes(type)) {
            return {
              value: e.product_code,
              label: `${e.product_code} - ${e.product_name}`,
            };
          } else {
            const val = type === "brand" ? e.brand : e.imum_category;
            return {
              value: val,
              label: val,
            };
          }
        }),
      ];

      if (type === "family") {
        options.splice(1, 0, {
          label: "No Category",
          value: "no_category",
        });
      }

      return options;
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  if (!["Imum", "ImumModal"].includes(current)) {
    return <Spinner />;
  }

  return (
    <div className="row">
      <ContentBlock containerClass="pt-3">
        <TableFilterBox
          mr={1}
          add={false}
          filter={!hiddenFilters}
          onFilter={() => onFilter()}
          clearFilter={
            hiddenFilters
              ? null
              : () => {
                setFilters(filterInitial);
                setCountriesAreDisplayed(
                  record_type == "technorama" ? ["LT"] : defaultLangs
                );
              }
          }
          button1={
            <>
              <RenderCustomButton
                countriesAreDisplayed={countriesAreDisplayed}
                filterString={filterString}
                checked={checked}
                page={page}
                preliminaryPreview={preliminaryPreview}
                setPreliminaryPreview={setPreliminaryPreview}
                user_id={user_id}
                failed={failed}
                setBulkTagModalVisible={setBulkTagModalVisible}
              />
              <ButtonInfo
                className={"mr-3"}
                onClick={() => {
                  setHiddenFilters((prev) => !prev);
                  setLocalStorage("imum_hidden_filters", !hiddenFilters);
                }}
              >
                {hiddenFilters ? (
                  <span>
                    <IconEye color="#1F1A54" /> Show
                  </span>
                ) : (
                  <span>
                    <IconEyeInvisible color="#1F1A54" /> Hide
                  </span>
                )}{" "}
                filter
              </ButtonInfo>
            </>
          }
        >
          <AnimatePresence>
            {!hiddenFilters && (
              <motion.div
                className="d-flex flex-wrap"
                initial={{ height: 0 }}
                animate={{ height: "auto" }}
                exit={{ height: 0 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
              >
                {record_type !== "technorama" && (
                  <div className="px-1">
                    <SelectCountry
                      mode={"multiple"}
                      value={countriesAreDisplayed}
                      onChange={(val) => setCountriesAreDisplayed(val)}
                    />
                  </div>
                )}
                <div className="px-1">
                  <DebounceSelect
                    label="SKU"
                    showSearch={true}
                    value={filters.product_code || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "product_code")}
                    onChange={(val) => {
                      setFilters((prev) => ({
                        ...prev,
                        product_code: val.value,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>

                <div className="px-1">
                  <DebounceSelect
                    label="Prod. title"
                    showSearch={true}
                    value={filters.product_name || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "product_name")}
                    onChange={(val) => {
                      setFilters((prev) => ({
                        ...prev,
                        product_name: val.value,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>

                <div className="px-1">
                  <DebounceSelect
                    label="Product category"
                    showSearch={true}
                    value={filters.family_name || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "family")}
                    onChange={(val) => {
                      setFilters((prev) => ({
                        ...prev,
                        family_name:
                          val.value === "no_category"
                            ? "no_category"
                            : val.value,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>

                <div className="px-1">
                  <DebounceSelect
                    label="Brand"
                    isMultiple={true}
                    showSearch={true}
                    value={filters.brand || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "brand")}
                    onChange={(val) => {
                      const brandValues = val.map((item) => item.value);
                      setFilters((prev) => ({
                        ...prev,
                        brand: brandValues,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>
                <div className="px-1">
                  <SelectInput
                    with_empty={true}
                    mode="multiple"
                    options={options?.imum_product_tags || []}
                    label="Special tag"
                    filterByLabel={true}
                    style={{
                      width: "165px",
                    }}
                    extra_label={
                      <div
                        className="SwitchCompContainer"
                        style={{ height: "14.5px" }}
                      >
                        <SwitchComp
                          className=""
                          classNameContainer="SwitchCompInnerContainer"
                          checkedChildren={<IconEyeInvisible color="#fff" />}
                          unCheckedChildren={<IconEye color="#fff" />}
                          checked={filters.tag_status}
                          onChange={(value) =>
                            setFilters((prev) => ({
                              ...prev,
                              tag_status: value,
                            }))
                          }
                          inlineText={filters.tag_status ? "Exclude" : "Show"}
                        />
                      </div>
                    }
                    value={filters.tag_ids || undefined}
                    onChange={(tag_ids) => {
                      let val = tag_ids;
                      if (val.includes("No special tag")) {
                        val = ["No special tag"];
                      }
                      setFilters((prev) => ({
                        ...prev,
                        tag_ids: val,
                      }));
                    }}
                  />
                </div>

                <div className="px-1">
                  <SelectForm
                    className={"select_with_hidden_items"}
                    placeholder="Competitor"
                    mode="multiple"
                    style={{ width: "165px" }}
                    dropdownMatchSelectWidth={false}
                    options={options?.shops || []}
                    onChange={(competitor) =>
                      setFilters((prev) => ({ ...prev, competitor }))
                    }
                    value={filters.competitor || undefined}
                  />
                </div>

                <div className="px-1">
                  <SelectForm
                    className={"select_with_hidden_items"}
                    placeholder="Cheapest Competitor"
                    style={{ width: "165px" }}
                    dropdownMatchSelectWidth={false}
                    options={options?.shops || []}
                    onChange={(cheapest_competitor) =>
                      setFilters((prev) => ({ ...prev, cheapest_competitor }))
                    }
                    value={filters.cheapest_competitor || undefined}
                  />
                </div>

                <div className="px-1">
                  <SelectForm
                    placeholder="Price changes"
                    options={[
                      { label: "All", value: "" },
                      { label: "Positive changes", value: "positive_changes" },
                      { label: "Negative changes", value: "negative_changes" },
                      { label: "No changes", value: "no_changes" },
                      // { label: "From highest to lowest", value: "2" },
                    ]}
                    selector="price_changes"
                    style={{ width: "165px" }}
                    value={filters?.price_changes || undefined}
                    onChange={(price_changes) =>
                      setFilters((prev) => ({ ...prev, price_changes }))
                    }
                  />
                </div>
                <div className="px-1">
                  <SelectForm
                    placeholder="Products"
                    options={[
                      { label: "All", value: "" },
                      { label: "Active", value: "active" },
                      { label: "Inactive", value: "inactive" },
                      { label: "Out of stock", value: "out_of_stock" },
                    ]}
                    selector="product_active"
                    style={{ width: "165px" }}
                    value={filters?.product_active || undefined}
                    onChange={(product_active) =>
                      setFilters((prev) => ({ ...prev, product_active }))
                    }
                  />
                </div>
                {failed ? (
                  <>
                    <div className="px-1">
                      <DataPickerInputModal
                        classNameLabel="text-sm-label"
                        text="Failure date"
                        name="failure_date"
                        style={{ width: "165px" }}
                        value={getDateFormat(filters.failure_date)}
                        onChange={(_, failure_date) =>
                          setFilters((prev) => ({
                            ...prev,
                            failure_date,
                          }))
                        }
                      />
                    </div>
                    <div className="px-1">
                      <SelectInput
                        with_empty={true}
                        mode="multiple"
                        style={{ width: "165px" }}
                        options={options?.imum_rules || []}
                        label="Rule names"
                        value={filters.imum_rule_ids || undefined}
                        onChange={(imum_rule_ids) => {
                          setFilters((prev) => ({
                            ...prev,
                            imum_rule_ids,
                          }));
                        }}
                      />
                    </div>
                    <div className="px-1">
                      <DebounceSelect
                        label="User"
                        style={{ width: "165px" }}
                        showSearch={true}
                        value={filters.user || undefined}
                        placeholder={"Enter"}
                        fetchOptions={(d) => fetchOptions4Filter(d, "user")}
                        onChange={(val) => {
                          setFilters((prev) => ({
                            ...prev,
                            user: val.value,
                          }));
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="px-1">
                      <DataPickerInputModal
                        text="Failure date"
                        classNameLabel="text-sm-label"
                        name="imum_prices_export_date"
                        value={getDateFormat(filters.imum_prices_export_date)}
                        onChange={(_, imum_prices_export_date) =>
                          setFilters((prev) => ({
                            ...prev,
                            imum_prices_export_date,
                          }))
                        }
                        style={{ width: "165px" }}
                      />
                    </div>
                    <div className="px-1">
                      <SelectInput
                        with_empty={true}
                        mode="multiple"
                        style={{ width: "165px" }}
                        options={options?.imum_rules || []}
                        label="Rule names"
                        value={filters.imum_prices_imum_rule_ids || undefined}
                        onChange={(imum_prices_imum_rule_ids) => {
                          setFilters((prev) => ({
                            ...prev,
                            imum_prices_imum_rule_ids,
                          }));
                        }}
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-end">
                      <div className="px-1">
                        <div className="d-flex flex-row">
                          <div>
                            <CheckBoxInput
                              checked={filters.no_competition}
                              onChange={() =>
                                setFilters((prev) => ({
                                  ...prev,
                                  no_competition: !prev.no_competition,
                                }))
                              }
                            />
                          </div>
                          <Label className="text-sm-label ml-1">
                            Show no new price
                          </Label>
                        </div>
                      </div>
                      <div className="px-1">
                        <div className="d-flex flex-row">
                          <div>
                            <CheckBoxInput
                              checked={filters.changed_price}
                              onChange={() =>
                                setFilters((prev) => ({
                                  ...prev,
                                  changed_price: !prev.changed_price,
                                }))
                              }
                            />
                          </div>
                          <Label className="text-sm-label ml-1">
                            Show changed not exported
                          </Label>
                        </div>
                      </div>
                    </div>

                    <div className="px-1">
                      <DebounceSelect
                        label="User"
                        showSearch={true}
                        value={filters.user || undefined}
                        placeholder={"Enter"}
                        fetchOptions={(d) => fetchOptions4Filter(d, "user")}
                        onChange={(val) => {
                          setFilters((prev) => ({
                            ...prev,
                            user: val.value,
                          }));
                        }}
                        style={{ width: "165px" }}
                      />
                    </div>
                  </>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </TableFilterBox>
        <div>
          <ContentValidation
            loader={false}
            array={current == "Imum" ? data : []}
          >
            {countriesAreDisplayed.length == 0 ? (
              <div className="font-semi-bold text-center text-xl py-3">
                No countries selected
              </div>
            ) : (
              <ImumProductTable
                countriesAreDisplayed={countriesAreDisplayed}
                data={current == "Imum" ? data : []}
                checked={checked}
                filterString={filterString}
                setChecked={setChecked}
                competitor={filters.competitor}
                table_sort={filters.table_sort}
                setFilters={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    [e.name]: e.value,
                  }))
                }
                page={page}
                loading={loading}
                lastBookElementRef={lastBookElementRef}
                hasMore={hasMore}
                imum_product_tags={options?.imum_product_tags || []}
                imum_rules={options?.imum_rules || []}
                failed={failed}
                totalLength={totalLength}
              />
            )}
          </ContentValidation>
        </div>
      </ContentBlock>
      {data?.length > 0 && !loading && !hasMore && (
        <div className="col-12">
          <p
            className="mb-0 text-sm text-center py-1"
            style={{
              color: "#797979",
            }}
          >
            Nothing to show more...
          </p>
        </div>
      )}
      <div>
        <InstructionButton />
      </div>

      <ImumBulkTagAction
        visible={bulkTagModalVisible}
        onClose={() => setBulkTagModalVisible(false)}
        checkedProductIds={checked}
        imumProductTags={options?.imum_product_tags || []}
        filterString={filterString}
        totalFilteredCount={totals || totalLength || 0}
        onSuccess={() => {
          setChecked([]);
          onFilter(true);
        }}
      />
    </div>
  );
};

const RenderCustomButton = ({
  countriesAreDisplayed,
  filterString,
  checked,
  preliminaryPreview,
  setPreliminaryPreview,
  user_id,
  failed,
  setBulkTagModalVisible,
}) => {
  const dispatch = useDispatch();

  const [importTagModal, setImportTagModal] = useState(false);

  return (
    <>
      <div className="float-left ml-1">
        <ButtonWithImumHistory
          actions={[
            {
              label: " Export selected prices",
              onClick: async (lang) => {
                if (checked.length == 0) return antdMessageInfo("Not selected");
                try {
                  const have_more_when_15 = await imumCheckIfHaveDifference({
                    ids: checked,
                    lang,
                  });
                  if (have_more_when_15.success) {
                    setPreliminaryPreview({
                      preview: true,
                      record: {
                        lang,
                        over_ids: have_more_when_15.data,
                        filterString,
                      },
                    });
                  } else {
                    dispatch(
                      exportImumToAlso(lang, "ids", checked, filterString)
                    );
                  }
                } catch (err) {
                  console.log(err);
                }
              },
              type: "default",
            },
            {
              label: " Change to old price",
              onClick: (lang) => imumMassChangePriceToOldPrice(lang, checked),
              type: "default",
            },
            {
              label: "Disable channel price visable",
              onClick: (lang, isFiltered) => {
                if (isFiltered) {
                  imumDisableChannelPriceScopeParams(lang, filterString);
                } else {
                  imumDisableChannelPriceScope(lang, checked);
                }
              },
              type: "disable_channel",
            },
          ]}
        />
      </div>
      <div className="float-right mr-3">
        <button
          className="btn btn-sm btn-dark"
          type="button"
          onClick={() => setBulkTagModalVisible(true)}
        >
          <i className="fa fa-tags mr-1"></i>
          Bulk Tag Management
        </button>
      </div>
      <div className="dropdown">
        <button
          className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Export
        </button>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenuButton"
        >
          {countriesAreDisplayed.length > 0 && (
            <>
              <button
                className="dropdown-item"
                onClick={() =>
                  getImumXls({
                    type: "get_imum_xls",
                    ids: checked,
                    filter: null,
                    countries: countriesAreDisplayed,
                    failed,
                  })
                }
              >
                Export selected (XLS)
              </button>
              <button
                className="dropdown-item"
                onClick={() =>
                  getImumXls({
                    type: "get_imum_xls",
                    filter: filterString,
                    countries: countriesAreDisplayed,
                    failed,
                  })
                }
              >
                Export filtered (XLS)
              </button>
            </>
          )}
          <button
            className="dropdown-item"
            onClick={() =>
              exportDocument(
                `/api/v1/imums/download_xlsx`,
                `imum_data_${user_id}.xlsx`,
                "POST",
                {
                  file_name: `imum_data_${user_id}.xlsx`,
                }
              )
            }
          >
            Download your last generated
          </button>
        </div>
      </div>
      <div className="dropdown">
        <button
          className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Import
        </button>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenuButton"
        >
          <button
            className="dropdown-item"
            onClick={() => setImportTagModal(true)}
          >
            Import tags
          </button>
        </div>
      </div>
      {preliminaryPreview?.preview && (
        <ImumModalPreliminaryPreview
          preliminaryPreview={preliminaryPreview}
          setPreliminaryPreview={setPreliminaryPreview}
        />
      )}

      {importTagModal && (
        <QueryClientProvider client={queryClient}>
          <ImumTagImport
            onClose={() => {
              setImportTagModal(false);
            }}
          />
        </QueryClientProvider>
      )}
    </>
  );
};

export default ImumExport;
